exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".upload--1qdK7 {\n\tpadding-bottom: 10px;\n\twidth: 180px;\n}\n\n\t.upload--1qdK7.fullWidth--fGRqj {\n\t\twidth: 100%;\n\t}\n", ""]);

// Exports
exports.locals = {
	"upload": "upload--1qdK7",
	"fullWidth": "fullWidth--fGRqj"
};